import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import { Link } from "react-router-dom";
const PrivacyPolicy = () => {
  return (
    <>
      <Header></Header>
      <div className="mainContent privacyPolicyWrap">
        <div className="privacyBannerWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2>Privacy Policy</h2>
              </div>
            </div>
          </div>
        </div>
        <div className="privacyPolicyDataWrap">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10">
                <div className="dataWrap">
                  <h4>Introduction</h4>
                  <p>
                    At Travasco, We value the privacy of our clients and are
                    committed to protecting the personal information you share
                    with us. This Privacy Policy outlines how we collect, use,
                    disclose, and safeguard your information when you visit our
                    website, use our services, or engage with us through other
                    channels.
                  </p>
                  <h3>1. Information We Collect</h3>
                  <p>We may collect the following types of information:</p>
                  <ul>
                    <li>
                      Personal Information: Includes your name, contact details
                      (such as email address, phone number, and mailing
                      address), date of birth, passport details, and payment
                      information.​
                    </li>
                    <li>
                      Travel Preferences and Plans: Details about your travel
                      plans, preferences, and special requirements.​
                    </li>
                    <li>
                      Technical Information: When you visit our website, we may
                      collect information such as your IP address, browser type,
                      operating system, and browsing behavior through cookies
                      and similar technologies.​
                    </li>
                  </ul>
                  <h3>2. How We Use Your Information</h3>
                  <p>Your information is used to:</p>
                  <ul>
                    <li>
                      Provide and manage travel bookings and related services.
                    </li>
                    <li>
                      Personalize your experience and offer tailored services.
                    </li>
                    <li>
                      Process payments and prevent fraudulent transactions.
                    </li>
                    <li>
                      Communicate with you regarding your bookings, inquiries,
                      or promotional offers.​
                    </li>
                    <li>
                      Comply with legal obligations and enforce our terms and
                      conditions.
                    </li>
                  </ul>
                  <h3>3. Sharing Your Information</h3>
                  <p>We may share your information with:</p>
                  <ul>
                    <li>
                      <strong>Service Providers: </strong> Such as airlines,
                      hotels, car rental companies, and tour operators to
                      fulfill your travel bookings.
                    </li>
                    <li>
                      <strong>Third-Party Vendors:</strong> Who provide services
                      on our behalf, including payment processing, data
                      analysis, and marketing assistance.​
                    </li>
                    <li>
                      <strong>Legal Authorities:</strong> When required by law
                      or to protect our rights and safety.
                    </li>
                  </ul>
                  <h3>4. Data Security</h3>
                  <p>
                    We implement appropriate technical and organizational
                    measures to protect your personal information against
                    unauthorized access, alteration, disclosure, or destruction.
                  </p>
                  <h3>5. Your Rights</h3>
                  <p>You have the right to:</p>
                  <ul>
                    <li>
                      Access, correct, or delete your personal information.​
                    </li>
                    <li>
                      Withdraw consent for processing your data where consent is
                      the basis of processing.
                    </li>
                    <li>
                      Object to the processing of your data in certain
                      circumstances.
                    </li>
                  </ul>
                  <p>
                    To exercise these rights, please contact us at [Your Contact
                    Information].
                  </p>
                  <h3>6. Cookies and Tracking Technologies</h3>
                  <p>
                    Our website uses cookies to enhance user experience, analyze
                    site usage, and assist in our marketing efforts. You can
                    manage your cookie preferences through your browser
                    settings.
                  </p>
                  <h3>7. Changes to This Privacy Policy</h3>
                  <p>
                    We may update this Privacy Policy periodically to reflect
                    changes in our practices or legal requirements. We encourage
                    you to review this policy regularly.
                  </p>
                  <h3>8. Contact Us</h3>
                  <Link to="https://travasco.com/" target="_blank">
                    https://travasco.com/
                  </Link>
                  <p>
                    Email us -{" "}
                    <Link to="mailto:info@travasco.com">
                      info@travasco.com
                    </Link>
                  </p>
                  <p>
                    WhatsApp/Messenger: Chat with us directly on [WhatsApp link]
                    or [Messenger link].
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </>
  );
};
export default PrivacyPolicy;
